export function showToast(message, type = "success", duration = 5000) {
  const toast = document.createElement("div");
  toast.className = `toast toast-${type}`;
  toast.innerHTML = `
    <div class="toast-message">${message}</div>
    <button class="toast-close-button">×</button>
  `;

  let container = document.querySelector(".toast-container");
  if (!container) {
    container = document.createElement("div");
    container.className = "toast-container";
    document.body.appendChild(container);
  }

  const closeButton = toast.querySelector(".toast-close-button");
  closeButton.addEventListener("click", () => {
    toast.classList.add("toast-hidden");
    setTimeout(() => toast.remove(), 300);
  });

  container.appendChild(toast);

  setTimeout(() => {
    toast.classList.add("toast-hidden");
    setTimeout(() => toast.remove(), 300);
  }, duration);
}
